import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetRegistryEventTaxDestinationQueryVariables = Types.Exact<{
  input: Types.RegistryEventTaxDestinationInput;
}>;

export type GetRegistryEventTaxDestinationQuery = {
  __typename?: 'Query';
  registryEventTaxDestination?: { __typename?: 'RegistryEventTaxDestination'; address: { __typename?: 'RegistryEventTaxDestinationAddress'; countryCode: string } } | null;
};

export const GetRegistryEventTaxDestinationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryEventTaxDestination' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryEventTaxDestinationInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryEventTaxDestination' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryEventTaxDestinationQuery__
 *
 * To run a query within a React component, call `useGetRegistryEventTaxDestinationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryEventTaxDestinationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryEventTaxDestinationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRegistryEventTaxDestinationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryEventTaxDestinationQuery, GetRegistryEventTaxDestinationQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetRegistryEventTaxDestinationQuery, GetRegistryEventTaxDestinationQueryVariables>(GetRegistryEventTaxDestinationDocument, baseOptions);
}
export function useGetRegistryEventTaxDestinationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryEventTaxDestinationQuery, GetRegistryEventTaxDestinationQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRegistryEventTaxDestinationQuery, GetRegistryEventTaxDestinationQueryVariables>(GetRegistryEventTaxDestinationDocument, baseOptions);
}
export type GetRegistryEventTaxDestinationQueryHookResult = ReturnType<typeof useGetRegistryEventTaxDestinationQuery>;
export type GetRegistryEventTaxDestinationLazyQueryHookResult = ReturnType<typeof useGetRegistryEventTaxDestinationLazyQuery>;
export type GetRegistryEventTaxDestinationQueryResult = Apollo.QueryResult<GetRegistryEventTaxDestinationQuery, GetRegistryEventTaxDestinationQueryVariables>;
